// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-management {
  position: relative; /* Ensure child elements are positioned relative to this container */
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border: 1px solid white;
  padding: 1rem;
  gap: 1rem;
}
.user-management__selectors {
  height: 5%;
}
.user-management__chart {
  height: 25%;
}
.user-management__preview-table {
  height: 70vh;
}
.user-management__main-counter {
  font-size: 1.25rem;
  display: flex;
  gap: 1.5vw;
  margin-top: 2vh;
}
.user-management__main-counter__label {
  font-weight: bold;
  color: black;
}
.user-management__main-counter__value {
  color: #7D7D7D;
  font-weight: 500;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(193, 193, 193, 0.32);
  z-index: 100;
}

.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 101;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/user-management/user-management.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA,EAAA,oEAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AACJ;AAAI;EACI,UAAA;AAER;AAAI;EACI,WAAA;AAER;AAAI;EACI,YAAA;AAER;AACI;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;AACR;AACQ;EACI,iBAAA;EACA,YAAA;AACZ;AACQ;EACI,cAAA;EACA,gBAAA;AACZ;;AAIA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,YAAA;AADJ;;AAIA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,YAAA;AADJ","sourcesContent":[".user-management {\n    position: relative; /* Ensure child elements are positioned relative to this container */\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    border: 1px solid white;\n    padding: 1rem;\n    gap: 1rem;\n    &__selectors{\n        height: 5%;\n    }\n    &__chart{\n        height: 25%;\n    }\n    &__preview-table{\n        height: 70vh;\n    }\n\n    &__main-counter{\n        font-size: 1.25rem;\n        display: flex;\n        gap: 1.5vw;\n        margin-top: 2vh;\n        \n        &__label{\n            font-weight: bold;\n            color: black;\n        }\n        &__value{\n            color: #7D7D7D;\n            font-weight: 500;\n        }\n    }\n}\n\n.mask {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(193, 193, 193, 0.32);\n    z-index: 100;\n}\n\n.popup {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: white;\n    padding: 2rem;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    z-index: 101;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
